export class DconConfigAPI {
  // static readonly KEYVAULT_API_URL: string = "https://qa-oracleofferingdfte.deloitte.com/azurekeyvaultapp/dftesecret/";
  // static readonly SW_ORDS_BASE_URL: string = "https://dev-myapex-oracleofferringdfte.deloitte.com/ords/DFTEDEV_PDB1/";
  // static readonly UI_PATH = "https://qa-uipath-oracleofferingdfte.deloitte.com";
  // static readonly NODE_URL = "https://dev-oracleofferingdfte.deloitte.com/Confighubapi";
  // static readonly redirectUri = 'https://confighub.dev-oracleofferringdfte.deloitte.com/';//"http://localhost:4200";
  static readonly KEYVAULT_API_URL: string =
    'https://dfte-test-smtp.deloitte.com:8000/secrets/get-secret/?secret_name=';
  static readonly SW_ORDS_BASE_URL: string =
    'https://dfte-test-apex.deloitte.com/ords/DFTE_GOLD/DFTE_CONFIGHUB_APPS';
  static readonly UI_PATH =
    'https://cloud.uipath.com/devdeloitterpa/DFTE/orchestrator_';
  static readonly UI_PATH_AUTH_URL =
    'https://cloud.uipath.com/identity_/connect/token';
  static readonly UI_PATH_CLIENT_ID = '4d516580-3881-4b21-9c9c-35a23566e8f2';
  static readonly UI_PATH_CLIENT_SECRET = 'yxZMJLb*Q%He6%@B';
  //static readonly NODE_URL = 'http://localhost:3042/api';
  static readonly NODE_URL = 'https://dev-oci-dfte.deloitte.com/api';
  static readonly projectInfo = 'PRJDEV1000_Project_Info';
  static readonly OrganizationUnitId = 169032;
  // static readonly redirectUri = 'http://localhost:4200';
  static readonly redirectUri = 'https://dev-oci-dfte.deloitte.com/';
  static readonly TENANCY_NAME: string = 'DFTEQA';
  static readonly UI_BATCH_KEY = 'batch_key/';
  static readonly UI_GRANT_TYPE = 'grant_type=client_credentials';
  static readonly APPLICATION: string = 'Confighub'; //"Confighub";//dcon
  static readonly API_FAILED: string = 'API call failed';
  static readonly UIPATH_PROCESS_NAME: string = 'MasterConfigHub';
  static readonly UIPATH_WORKBOOK_PROCESS_NAME: string = 'MasterConfigWorkBook';
  static readonly DCON_SECURITY_CREDENTIALS: string = 'DFTE_SW_ORDS_CRED';
  static readonly ORDS_CRED_ASSET: string = '_CONFIGHUB_DBORDS_Credentials'; // Project_
  static readonly ORDS_URL_ASSET: string = '_CONFIGHUB_DBORDS_Hostname'; // Project_
  static readonly LEGACY_EXTRACT_APPLICABLE_ASSET: string =
    '_LegacyExtract_Applicable';
  static readonly DCON_UIPATH_CREDENTIALS: string = '_UIPATH_Credentials';
  static readonly CONFIGHUB_WINDOWS_FILE_SHARE_PATH: string =
    'CONFIGHUB_WINDOWS_FILE_SHARE_PATH';
  static readonly DFTE_WORKBENCH_ORDS_URL: string = 'DFTE_WORKBENCH_ORDS_URL';
  static readonly CONFIG_TEMPLATE_PATH: string =
    'DCON_CONFIGURATION_TEMPLATE_PATH';
  static readonly SFTP_PATH: string = '_DMZSFTP_Root';
  static readonly SFTP_PORT: string = '_DMZSFTP_Port';
  static readonly SFTP_HOST: string = '_DMZSFTP_Host';
  static readonly SFTP_CREDENTIALS: string = '_DMZSFTP_Credentials';
  static readonly DFTE_CONFIGHUB_APPS: string = 'DFTE_CONFIGHUB_APPS/';
  static readonly UIPATH_COMPARE_PROCESS_NAME: string = 'MasterConfigHub';
  static readonly USE_CONFIGBUILD_FEATURE: boolean = true;
  static readonly URL_PROPS = {
    WORKBOOKTEMPLATE: 'WorkbookTemplates',
    GET_BATCHKEY_UI: 'get_batchkey_ui?&',
    GET_AUTO_EXTRACT_DETAILS: 'get_auto_extract_details?&',
    INSERT_AUTO_EXTRACT: 'insert_autoextract_details?&',
    GET_BATCHKEY_DETAILS_UI: 'get_batchkey_details_ui?&',
    UPDATE_BATCHKEY_DETAILS: 'update_batchkey_details?&',
    GET_INSTANCE_DETAILS: 'get_instance_details?&',
    GET_CONFIG_DETAILS: 'get_config_details?&',
    GET_CLOUD_EXTRACT_LOV: 'get_cloudextract_lov_details?',
    INSERT_BATCHKEY_DETAILS: 'insert_batchkey_details?&',
    UPDATE_PARAMS_DETAILS: 'update_batchkey_details_para?',
    ODATA_RELEASES_FILTER: "/odata/Releases?$filter=ProcessKey eq '",
    ODATA_ASSETS_FILTER: "/odata/Assets?$filter=Name eq '",
    ODATA_FOLDER_FILTER: "/odata/Folders?$filter=DisplayName eq '",
    ODATA_JOBS_STARTJOBS:
      '/odata/Jobs/UiPath.Server.Configuration.OData.StartJobs',
    GLOBAL_TRANSFORMATION: '/global_transaformation?&',
    LEGACY_EXTRACT: 'Legacy_Extract?&',
    GET_CONFIG_TRANSFORM_DETAILS: 'get_config_transform_details?&',
    GET_BATCH_ENTITY_DETAILS_UI: 'get_batch_entity_details_ui?&',
    GET_ENTITY_NAME_UI: 'get_entity_name_ui?&',
    INSERT_ENTITY_DETAILS: 'insert_entity_details?&',
    GET_CONFIG_WORKBOOK_DATA: 'configbook_get_workbook_data?',
    GET_CONFIG_WORKBOOK_BATCH_KEYS_REV: 'configwb_get_workbook_batchkeys_rev?',
    GET_CONFIG_WORKBOOK_BATCH_KEY_EXTRACT_DETAILS:
      'configbook_get_batchkey_extract_details?',
    INSERT_CONFIGBOOK_INSERT_BATCHKEY: 'configbook_insert_batchkey_workbook?',
    INSERT_CONFIGBOOK_REVERSE_INSERT_BATCHKEY:
      'configwb_insert_batchkey_workbook_hdr_rev?',
    CONGIGBOOK_CONFIG_DETAILS: 'configbook_get_config_workbook_details?',
    CONGIGBOOK_INSERT_LINE_CONFIG_DETAILS:
      'configwb_insert_batchkey_workbook_line_rev?',
    CONGIGBOOK_UPDATE_WORKBOOK_TEMPLATE: 'configbook_update_workbook_template?',
    GET_CONFIGBOOK_COMPARE_STATUS: 'configbook_get_compare_status?',
    UPLOAD_WORKBOOK: '/workbook/upload',
    UPLOAD_CLOUD_LOAD: '/cloudload/upload',
    UPLOAD_COMPARE: '/configcompare/upload',
    CREATE_WORKBOOK: '/workbook/createWorkbook',
    GET_REPORT: '/cloudextract/getReport',
    CREATE_WORKBOOKEXTRACT: '/workbook/createWorkbookExtract',
    COMPARE_FILE_TO_INSTANCE: '/configcompare/compareFileToInstance',
    DOWNLOAD_WORKBOOK: '/workbook/workbookDownload',
    DOWNLOAD_WORKBOOKEXTRACT: '/workbook/csvExtractDownload',
    GET_SFTP_FILE: '/sftp/getSFTPfile',
    PUT_SFTP_FILE: '/sftp/putSFTPfile',
    ODI_LOADFILECREATION: '/api/odi/loadfilecreation',
    ODI_AUTO_EXTRACT: '/api/odi/extract',
    ODI_AUTO_UPLOAD: '/api/odi/autouploadprocess',
    BOT_DOWNLOAD_FILE: '/Bot/downloadFile',
    BOT_DOWNLOAD_USER_GUIDE: '/Bot/downloadFile/userGuide',
    BOT_DOWNLOAD_VIDEO: '/Bot/downloadFile/video',
    DOWNLOAD_COMPARE: '/configcompare/summaryDownload',
    CLOUDLOAD_CREATEFOLDER: '/cloudload/networkFolderCreation',
    CLOUD_LOAD_DOWNLOAD: '/cloudload/cloudloadDownload',
    CLOUD_EXTRACT_DOWNLOAD: '/cloudextract/cloudextractDownload',
    GET_CLOUDLOAD_DATA: 'get_cloudload_data?&',
    GET_BATCHKEY_DATA: 'get_batchkey_data?&',
    GET_FILE_STATUS: '/api/odi/getFileStatus',
    WORKBOOK_TEMPLATE_DOWNLOAD: '/workbook/workbookTemplateDownload',
    UPLOAD_XLSX_FILE: '/upload-xlsx',
    GET_MODULE_DETAILS: '/get_module_details',
    MODULES_TO_TASK: '/get_task_per_module_data',
    TASK_STATUS: '/update_task_status',
    DOWNLOAD_XLSX_FILE: '/download-xlsx',
    LOGIN_USER: '/user/login',
    LOGOUT_USER: '/user/logout',
    UPDATE_PASSWORD: '/user/reset-password',
    GET_USERS_ADMIN_DASHBOARD: '/user/getuser',
    ADD_USER_ADMIN: '/user/adduser',
    UPDATE_ADMIN_USER: '/user/updateUser',
    RESET_ADMIN_PASSWORD: '/user/reset-password/admin',
    RESET_USER_PASSWORD: '/user/reset-password/user',
  };

  static readonly API_VARIABLES = {
    Request_Type_Extract: 'EXTRACT',
    Request_Type_Load: 'LOAD',
    Request_Type_ConfigWorkbook: 'CONFIG WORKBOOK',
    Request_Type_Compare: 'COMPARE',
    CLOUD: 'CLOUD',
    EBS: 'EBS',
    FILE: 'FILE',
    LEGACY: 'LEGACY',
    WORKBOOK: 'WORKBOOK',
    Extract_Type_SQL: 'SQL',
    Extract_Type_FILE: 'FILE',
  };

  static readonly CODE_VARIABLES = {
    Admin_User: 'Maintainer',
  };
}
